<template>
    <div class="export-dialog">
        <!-- 匹配订单护照页-->
        <el-dialog :visible.sync="dialogShow" width="1000px" :close-on-click-modal="true" @closed="handleClosed">
            <div class="dialog-member-title">
                <span class="dialog-member-name">批量导出申请人测试</span>
                <div class="dialog-close" @click="closeFn">
                    <i class="el-icon-close"></i>
                </div>
            </div>
            <div v-loading="loading">
                <div class="dialog-member-content">
                    共查询到 {{ dataList.length }} 条数据
                </div>
                <VirtualTable ref="virtualTableRef" :table-data="dataList" :table-height="600" :row-height="48"
                    :row-key="'id'" :checkedIds="checkedIds">
                    <template slot="columns">
                        <el-table-column prop="applicantName" label="申请人姓名"></el-table-column>
                        <el-table-column prop="passportNumber" label="护照号"></el-table-column>
                        <el-table-column prop="genderName" label="性别" width="50"></el-table-column>
                        <el-table-column prop="birthDay" label="出生日期"></el-table-column>
                        <el-table-column prop="passportIssue" label="护照生效日期" width="110"></el-table-column>
                        <el-table-column prop="passportValidity" label="护照有效期"></el-table-column>
                        <el-table-column prop="statusName" label="申请人状态"></el-table-column>
                        <el-table-column prop="applyNumber" label="申请编号"></el-table-column>
                        <el-table-column prop="serviceMarks" label="订单备注"></el-table-column>
                        <el-table-column prop="latestStatus" label="失败原因"></el-table-column>
                    </template>
                </VirtualTable>
                <div class="dialog-member-content">
                    <el-button type="primary" @click="submitSelectionUpload">导出全部</el-button>
                    <el-button type="primary" @click="handleExporetSelect">导出已选择</el-button>
                    <el-button @click="closeFn">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { batchimportapplicant } from "@/api/order";
import { export_json_to_excel } from '@/utils/Export2Excel';
import VirtualTable from "./VirtualTable.vue";

export default {
    name: "orderDownloadDialog",
    data() {
        return {
            dialogShow: false,
            loading: false,
            dataList: [],
            checkedIds: [],
            virtualTableRef: null,
        };
    },
    components: {
        VirtualTable
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        formDate: {
            type: Object,
            default: () => ({})
        },
        PlanVisaDateTime: {
            type: Array,
            default: () => ([])
        },
        dateInfo: {
            type: Array,
            default: () => ([])
        }
    },
    watch: {
        visible(val) {
            this.dialogShow = val;
            if (val) {
                console.log('visible', val);
                console.log(this.formDate, this.PlanVisaDateTime, this.dateInfo)
                this.handleGetFailData()
            }
        }
    },
    methods: {
        closeFn() {
            this.$emit('close')
        },
        handleClosed() {
            // 清除数据
            this.dataList = []
            this.checkedIds = []
            this.$emit('close')
        },
        // 获取失败数据
        handleGetFailData() {
            this.loading = true
            let tempData = { ...this.formDate }
            let data = {
                "Page.Size": tempData.pageSize,
                "Page.Index": tempData.pageIndex,
                CountryId: tempData.CountryId,
                VisaTypeId: tempData.VisaTypeId,
                OrderStatus: tempData.OrderStatus,
                OrderSource: tempData.OrderSource,
                ApplcantStatus: tempData.ApplcantStatus,
                Key: tempData.Key,
                StartTime: tempData.StartTime,
                EndTime: tempData.EndTime,
                MerchatId: tempData.MerchatId,
                AppIdLong: tempData.AppIdLong,
                Status: tempData.menuActive,
                PayType: tempData.PayType,
            }
            if (!this.PlanVisaDateTime) {
                tempData.PlanVisaStartTime = "";
                tempData.PlanVisaEndTime = "";
            } else {
                tempData.PlanVisaStartTime = this.PlanVisaDateTime[0];
                tempData.PlanVisaEndTime = this.PlanVisaDateTime[1];
            }
            if (!this.dateInfo) {
                tempData.StartTime = "";
                tempData.EndTime = "";
            } else {
                tempData.StartTime = this.dateInfo[0];
                tempData.EndTime = this.dateInfo[1];
            }
            batchimportapplicant(data).then(res => {
                console.log(res)
                if (res.code == 1) {
                    this.dataList = res.data.row.map(item => {
                        return {
                            ...item,
                            birthDay: item.birthDay ? this.$moment(item.birthDay).format('YYYY-MM-DD') : '',
                            passportValidity: item.passportValidity ? this.$moment(item.passportValidity).format('YYYY-MM-DD') : '',
                            passportIssue: item.passportIssue ? this.$moment(item.passportIssue).format('YYYY-MM-DD') : '',

                        }
                    })
                }
            }).finally(() => {
                this.loading = false;

            })
        },
        submitSelectionUpload() {
            this.exportMethod(this.dataList)
            this.$message.success(`正在导出 ${this.dataList.length} 条数据`)

        },
        handleExporetSelect() {
            const selection = this.$refs.virtualTableRef.getSelection()
            console.log('导出数据:', selection)
            this.$message.success(`正在导出 ${selection.length} 条数据`)
            this.exportMethod(selection)
        },
        exportMethod(exportData) {
            const tHeader = ['申请人姓名', '护照号', '性别', '出生日期', '护照生效日期', '护照有效期', '申请人状态', '申请编号', '订单操作备注', '失败原因'] // 表格头部
            const filename = '申请人信息表'
            let data = exportData.map(item => {
                return [
                    item.applicantName,
                    item.passportNumber,
                    item.genderName,
                    item.birthDay,
                    item.passportIssue,
                    item.passportValidity,
                    item.statusName,
                    item.applyNumber,
                    item.serviceMarks,
                    item.latestStatus,
                ]
            })
            console.log(data);
            console.log(filename);
            console.log(tHeader);
            
            
            
            export_json_to_excel({
                header: tHeader,
                data,
                filename
            })
        }
    },
    created() { },
};
</script>

<style lang="scss">
.export-dialog {

    .el-dialog {
        background-color: transparent;

        .el-dialog__header {
            display: none !important;
        }

        .el-dialog__body {
            background: linear-gradient(180deg, #e7ecfb 0%, #f6f8fe 24%, #ffffff 100%);
            border-radius: 12px;
            box-sizing: border-box;
            overflow: hidden;
        }
    }

    .dialog-member-content {
        padding: 10px;
    }
}
</style>